<template>
  <v-navigation-drawer
    floating
    clipped
    width="300"
    class="pt-10"
    v-model="navigation.sidebar"
    app
  >
    <v-list shaped>
      <v-list-item-group color="#34c759">
        <v-list-item
          v-for="item in sidebar"
          :key="item.title"
          link
          :to="item.to"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  data: () => ({
    menudrawer: null,
    sidebar: [
      { title: "Dashboard", icon: "fal fa-home-lg-alt", to: "/" },
      {
        title: "Profielen",
        icon: "fal fa-user-friends",
        to: "/profiles",
      },
      {
        title: "Bedrijven",
        icon: "fal fa-box-full",
        to: "/companies",
      },
      {
        title: "Instellingen",
        icon: "fal fa-cog",
        to: "/settings",
      },
      // { title: "Support", icon: "fal fa-thumbs-up", to: "/support" },
    ],
  }),
  computed: {
    ...mapGetters({ navigation: "getnavigation" }),
  },
};
</script>

<style>
.v-navigation-drawer .v-icon {
  width: 25px;
}
</style>
